import React, { useState } from 'react';

import { Slot } from '@radix-ui/react-slot';

import * as Dropdown from 'src/components/elements/Dropdown';
import { InclineArrow, Minus, Pin, Plus } from 'src/components/elements/Icons';

import type { News } from '../../types';
import * as BaseNews from './News';

import styles from './News.scss';

type BaseNewsProps = Omit<News, 'priority' | 'id'>;

export const NewsCard = ({ title, image, category, links, isPinned }: BaseNewsProps) => {
  const [isMenuOpened, setMenuOpened] = useState(false);

  const isSingleLink = links.length === 1;

  const handleNewsClick = () => {
    setMenuOpened(!isSingleLink);
  };

  const Wrapper = isSingleLink ? 'a' : Slot;

  return (
    <Wrapper
      className={styles.newsCard}
      {...(isSingleLink && {
        target: '_blank',
        href: links?.[0]?.link,
      })}
      onClick={handleNewsClick}
    >
      <BaseNews.Root>
        <BaseNews.PictureWrapper>
          {image && <BaseNews.Picture sources={[]} src={image} />}
        </BaseNews.PictureWrapper>

        <BaseNews.Content>
          <BaseNews.Wrapper>
            <BaseNews.Label>{category}</BaseNews.Label>
            <BaseNews.Title>{title}</BaseNews.Title>
          </BaseNews.Wrapper>

          {isSingleLink && (
            <BaseNews.Action asChild={true}>
              <BaseNews.Link target="_blank" href={links[0].link}>
                {links[0].label} ↗
              </BaseNews.Link>
            </BaseNews.Action>
          )}

          {links.length > 1 && (
            <Dropdown.Menu open={isMenuOpened} onOpenChange={setMenuOpened}>
              <Dropdown.MenuTrigger asChild>
                <BaseNews.Action asChild className={styles.dropdownAction}>
                  {isMenuOpened ? (
                    <span>
                      Hide sources
                      <Minus className={styles.dropdownIcon} />
                    </span>
                  ) : (
                    <span>
                      Show sources
                      <Plus className={styles.dropdownIcon} />
                    </span>
                  )}
                </BaseNews.Action>
              </Dropdown.MenuTrigger>

              <Dropdown.MenuContent side="top" className={styles.dropdownContent}>
                {links.map((linkItem, index) => (
                  <Dropdown.MenuItem key={index}>
                    <BaseNews.Link
                      target="_blank"
                      className={styles.dropdownLink}
                      href={linkItem.link}
                    >
                      {linkItem.label}
                      <InclineArrow className={styles.dropdownIcon} />
                    </BaseNews.Link>
                  </Dropdown.MenuItem>
                ))}
              </Dropdown.MenuContent>
            </Dropdown.Menu>
          )}
        </BaseNews.Content>

        {isPinned && (
          <BaseNews.Tag className={styles.newsPinned}>
            <Pin className={styles.newsPinnedIcon} />
            Pinned
          </BaseNews.Tag>
        )}
      </BaseNews.Root>
    </Wrapper>
  );
};
